module.exports = __webpack_public_path__ + "static/media/Lato-Light.cf44fd55.ttf";